function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Inputbox } from '../../../Inputbox';
import { SelectMenuContext } from '../../context';
function SearchBar(props) {
  const {
    searchValue,
    handleSearch,
    searchInputProps,
    searchPlaceholder,
    isSearchClearable,
    handleResetSearch
  } = props;
  const {
    searchBarRef
  } = useContext(SelectMenuContext);
  return /*#__PURE__*/React.createElement(Inputbox, _extends({
    ref: searchBarRef,
    inputType: "search",
    value: searchValue,
    placeholder: searchPlaceholder,
    onChange: event => {
      const searchedValue = event.target.value;
      handleSearch(searchedValue);
    },
    clearable: isSearchClearable
  }, searchInputProps, {
    onReset: event => {
      handleSearch('');
      handleResetSearch(event);
    }
  }));
}
SearchBar.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  handleResetSearch: PropTypes.func.isRequired,
  searchInputProps: PropTypes.object,
  isSearchClearable: PropTypes.bool.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired
};
export default SearchBar;